import { createContext, useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { SingleCustomerContextType, SinglecustomerInitialState } from "../../../types/types";
import { fetchCustomersFor360,
  getCustomersEvidence,
  getIdea,
  getSingleCustomerEvidence,
  getUnreadNotificationsCount,
  fetchConfigFor360,
  getSettingsForAccount, } from "../../../Api";
import { getBagelId, useThrottle } from "../../../utils";

import { useDisclosure } from "@mantine/hooks";

const SingleCustomerContext = createContext<SingleCustomerContextType>(SinglecustomerInitialState);

const SingleCustomerContextProvider = ( { children } : { children: React.ReactNode } ) => {

  const auth0 = useAuth0();
  const userId = getBagelId(auth0.user);
  const user = auth0.user
  

  const [threeSixtyConfig, setThreeSixtyConfig] =  useState<any>({})
  const [threeSixtyColumns, setThreeSixtyColumns] = useState<any[]>([])
  const [allComponents, setAllComponents] = useState<any[]>([])
  const [domains, setDomains] = useState<any[]>([])
  const [ideaStatuses, setIdeaStatuses] = useState<any[]>([])
  const [impactAggregationProperties, setImpactAggregationProperties] = useState<any>([]);
  const [ideaInfoTabsConfig, setIdeaInfoTabsConfig] = useState<any>({});
  const [customerIds, setCustomerIds] = useState<string[]>([])
  const [ideas, setIdeas] = useState<any[]>([]) 
  const [customer, setCustomer] = useState<any>({})
  const [customers, setCustomers] = useState<any[]>([])
  const [ cardOpened , setCardOpened ] = useState(false);
  const [customersItems, setCustomersItems] = useState<any[]>([])
  const [account, setAccount] = useState<any>(null);
  /* const [accountObj, setAccountObj] = useState<any>(null); */
  const [accountName, setAccountName] = useState<string>("");
  const [totalCustomersCount, setTotalCustomersCount] = useState<number>(0)
  const [chosenCustomer, setChosenCustomer] = useState<any>({})
  const [activeFilters, setActiveFilters] = useState<any[]>([])
  const [ chosenEvidence , setChosenEvidence ] = useState<any>({});
  const [chosenIdea, setChosenIdea] = useState<any>({});
  const [textQuery, setTextQuery] = useState<string>('')
  const [unreadNotificationsMap, setUnreadNotificationsMap] = useState<any[]>(
    []
  );
  const [comments, setComments] = useState<any>({});
  const [unreadNotificationsLoading, setUnreadNotificationsLoading] =
    useState<boolean>(false);
  const [ideaId, setIdeaId] = useState<any>(null);
  const [activityOpened, setActivityOpened] = useState(false);
  const [isModalOpen, { open: openModal, close: closeModal }] = useDisclosure(false);
  const [isLoading, setIsLoading] = useState(false);
  const [ideasLoading, setIdeasLoading] = useState(false);
  const [idea, setIdea] = useState({})
  const [loadingIdea, setLoadingIdea] = useState(false)
  const [chosenCustomers, setChosenCustomers] = useState<any[]>([])
  const [evidences, setEvidences] = useState<any[]>([])
  const [evidenceId, setEvidenceId] = useState<string>('')
  const [loadingEvidence, setLoadingEvidence] = useState(false)
  const [isMultipleCustomers, setIsMultipleCustomers] = useState(false)
  const [isSegmentSelection, setIsSegmentSelection] = useState<boolean>(false)
  const [isSingleSelection, setIsSingleSelection] = useState<boolean>(false)
  const [groupBy, setGroupBy] = useState<string>('domainId')
  const [isReadyForSelect, setisReadyForSelect] = useState<boolean>(true)
  const [ideasFiltersConfig, setIdeasFiltersConfig] = useState<{
    evidence:any,
    idea:any
  }>(
    {
      evidence: {},
      idea: {},
    }
  );
  const [viewType, setViewType] = useState<'single' | 'multiple' | 'segment'>('segment')


  /* const loadAccount = () => {

    getSettingsForAccount(auth0)
      .then(connectedAccount => {
        setAccountObj(connectedAccount)
   
      })
      .catch((error) => console.log(error));
  }; */

  const loadIdea = async () => {
    if (!ideaId) {
      return false;
    }
    setLoadingIdea(true)
    const res = await getIdea(ideaId, auth0);
    setLoadingIdea(false)
    setIdea(res);
  
  };


  const openActivity = () => {
    setActivityOpened(true);
  };

  const getUnreadNotifications = async () => {
    if (!ideaId) {
      return false;
    }
    setUnreadNotificationsLoading(true);
    await getUnreadNotificationsCount(ideaId, auth0)
      .then(({ requests }) => {
        setUnreadNotificationsMap(requests);
      })
      .catch((e) => console.log(e))
      .finally(() => setUnreadNotificationsLoading(false));
  };

  const getUnreadNotificationsCountByRequest = (requestId: string) => {
    return (
      unreadNotificationsMap.find((request) => request._id == requestId)
        ?.unreadNotificationsCount || 0
    );
  };

  
  async function fetchCustomersEvidence(orgIds: string[], view: 'single' | 'multiple' | 'segment') {
    if (!orgIds) return;
    
    setIdeasLoading(true);
    try {
      const res = await getCustomersEvidence(orgIds, auth0);
      if (res) {
        if(res.ideas === 0){
          handleModalOpen()
        }
        setIdeas(res?.ideas || []);
        setCustomers(res?.customers || {});
    
        if (res.customers.length == 1) {
          setIsSingleSelection(true)
          setIsSegmentSelection(false)
          setViewType('single')

          if(groupBy === 'demand') {
            setGroupBy('domainId')
          }
        }
        else {
          setViewType(view)
          setIsSingleSelection(false)
          setIsSegmentSelection(true)
        }

        if(activeFilters.length > 0 && textQuery === '' && customerIds.length === 0) {
          setIsSingleSelection(false)
          setIsSegmentSelection(true)
          setViewType(view)
        }
        

        setCustomer(res.customers[0])
      }


      /* const res2 = await saveCustomer360Views(userId ,orgIds, 'single', auth0); // PHASE 5
      if (res2) {
        console.log(res2)
      } */

    } catch (e) {
      console.error('Error fetching customer evidence:', e);
      // Optionally show error to user
    } finally {
      setIdeasLoading(false);
    }
  }

  async function fetchSingleCustomerEvidence(evidenceId: string) {
    if (!evidenceId) return;
    
    setLoadingEvidence(true);
    try {
      const res = await getSingleCustomerEvidence(evidenceId, auth0);
      if (res) {
        setChosenEvidence(res[0])
      }
    } catch (e) {
      console.error('Error fetching customer evidence:', e);
    } finally {
      setLoadingEvidence(false);
    }
  }

  const fetchCustomers = () => {
    setIsLoading(true);
    setisReadyForSelect(true)
    fetchCustomersFor360(textQuery, activeFilters, auth0)
      .then((res:any)=>{
        setCustomersItems(res.customers)
        setTotalCustomersCount(res.totalCount)

        if(res.isReadyForSelect === false){
          setisReadyForSelect(false)
        }

      }).catch((e:any)=>{
        console.log(e)
      }).finally(() => {
        setIsLoading(false);
      })
  }

  const fetchCustomersForOpenModal = () => {
    setIsLoading(true);
    fetchCustomersFor360('', [], auth0)
      .then((res:any)=>{
        setCustomersItems(res.customers)
        setTotalCustomersCount(res.totalCount)
      }).catch((e:any)=>{
        console.log(e)
      }).finally(() => {
        setIsLoading(false);
      })
  }

  const fetchConfig = () => {
    setIsLoading(true);
    fetchConfigFor360(auth0)
      .then((res: any)=>{
        setIdeasFiltersConfig(res.ideasFiltersConfig)
        if(res.threeSixtyConfiguration){
          setThreeSixtyConfig(res.threeSixtyConfiguration || {})
          setThreeSixtyColumns(res.threeSixtyConfiguration?.colomns || [])
        }
        setAllComponents(res.allComponents)
        setDomains(res.domains)
        setIdeaStatuses(res.ideaStatuses)
        setImpactAggregationProperties(res.impactAggregationProperties)
        setIdeaInfoTabsConfig(res.ideaInfoTabsConfig)
      }).catch((e:any)=>{
        console.log(e)
      }).finally(() => {
        setIsLoading(false);
      })
  }

  const throttledSearch = useThrottle(() => {
    fetchCustomers()
  }, 1000);


  const handleModalOpen = () => {
    setActiveFilters([])
    fetchCustomersForOpenModal()
    openModal()
  }

  useEffect(() => {
    if (textQuery !== '') {

      throttledSearch();
    } else {
     
      fetchCustomers()
    }
  }, [activeFilters, textQuery]);


  useEffect(() => {
    
    if (customerIds.length > 0 && viewType) {
      const storageItem = {
        userId,
        viewType,
        filters :activeFilters,
        orgIs: customerIds,
        
      };
      
      // Get existing views from localStorage
      const existingViews = JSON.parse(localStorage.getItem('customer360Views') || '[]');
      
      // Find if there's an existing view for this userId
      const existingIndex = existingViews.findIndex((view: any) => view.userId === userId);
      
      if (existingIndex !== -1) {
        // Update existing view
        existingViews[existingIndex] = storageItem;
      } else {
        // Add new view
        existingViews.push(storageItem);
      }
      
      // Save updated array back to localStorage
      localStorage.setItem('customer360Views', JSON.stringify(existingViews));
    }
  }, [customerIds, activeFilters ]);

  // Update the initial load useEffect to set activeFilters from localStorage
  useEffect(() => {

    fetchConfig()
    // Initial load - check localStorage
    const savedViews = JSON.parse(localStorage.getItem('customer360Views') || '[]');
    const userView = savedViews.find((view: any) => view.userId === userId);

 
    
    if (!userView) {
      // Scenario 1: No saved data, open modal
      handleModalOpen();
    } else if (userView.orgIs && userView.orgIs.length > 0 /* && userView?.accountId === accountObj?._id */) {
      // Scenario 2: Found saved data with orgIds, fetch evidence
      setCustomerIds(userView.orgIs);
      setViewType(userView.viewType);
      setActiveFilters(userView.filters || []);
      fetchCustomersEvidence(userView.orgIs, userView.viewType);
    } else {
      // Scenario 3: Found saved data but no orgIds, open modal
      handleModalOpen();
    }
  }, [userId]);

  // Add new useEffect to handle evidence fetching when customerIds change
  useEffect(() => {
    if (customerIds.length > 0 && viewType) {
      fetchCustomersEvidence(customerIds, viewType);
    }
  }, [customerIds]);

 


  return (
    <SingleCustomerContext.Provider
      value={{
        ideas,
        ideaStatuses,
        allComponents,
        customer,
        cardOpened,
        setCardOpened,
        chosenEvidence,
        setChosenEvidence,
        threeSixtyConfig,
        activeFilters,
        setActiveFilters,
        textQuery,
        setTextQuery,
        customersItems,
        setCustomersItems,
        totalCustomersCount,
        chosenCustomer,
        setChosenCustomer,
        isModalOpen,
        openModal,
        closeModal,
        account,
        accountName,
        setAccountName,
        setAccount,
        comments,
        setComments,
        getUnreadNotificationsCountByRequest,
        getUnreadNotifications,
        unreadNotificationsLoading,
        ideaId,
        setIdeaId,
        activityOpened,
        setActivityOpened,
        openActivity,
        chosenIdea,
        setChosenIdea,
        domains,
        isLoading,
        ideasLoading,
        threeSixtyColumns,
        customerIds,
        setCustomerIds,
        customers,
        setCustomers,
        loadIdea,
        chosenCustomers,
        evidences,
        evidenceId,
        setEvidenceId,
        fetchSingleCustomerEvidence,
        loadingEvidence,
        setLoadingEvidence,
        isMultipleCustomers,
        setIsMultipleCustomers,
        isSegmentSelection,
        setIsSegmentSelection,
        handleModalOpen,
        isSingleSelection,
        setIsSingleSelection,
        ideasFiltersConfig,
        groupBy,
        setGroupBy,
        isReadyForSelect,
        viewType,
        setViewType,
        impactAggregationProperties,
        setThreeSixtyConfig,
        ideaInfoTabsConfig
      }}
    >
      {children}
    </SingleCustomerContext.Provider>
  );
};

export { SingleCustomerContext, SingleCustomerContextProvider };
export default SingleCustomerContext;